module.exports = __webpack_public_path__ + "static/media/defaultgame.a6aea991.png";